//@flow

export const HEADER_BANNER_FORM_FIELDS = {
  CONTENT: 'content',
  BACKGROUND_COLOR: 'backgroundColor',
  TEXT_COLOR: 'textColor',
  BUTTON_URL: 'buttonUrl',
  BUTTON_TEXT: 'buttonText',
};
